// extracted by mini-css-extract-plugin
export default {"tableHeaderCell":"TableHeaderCell_tableHeaderCell__7Wj0L","headingLabel":"TableHeaderCell_headingLabel__493Bq"};